// extracted by mini-css-extract-plugin
export default {"infoNote":"style_infoNote__4r5s2","infoNoteIcon":"style_infoNoteIcon__oo6E7","infoNoteTitle":"style_infoNoteTitle__ntU8g","infoNoteList":"style_infoNoteList__xq1XN"};